import { __assign } from "tslib";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Hive = React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return React.createElement(StyledIconBase, __assign({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), React.createElement("path", {
    d: "M20.895 7.553l-2-4A1.001 1.001 0 0018 3h-5c-.379 0-.725.214-.895.553L10.382 7H6c-.379 0-.725.214-.895.553l-2 4a1 1 0 000 .895l2 4c.17.338.516.552.895.552h4.382l1.724 3.447A.998.998 0 0013 21h5c.379 0 .725-.214.895-.553l2-4a1 1 0 000-.895L19.118 12l1.776-3.553a1 1 0 00.001-.894zM13.618 5h3.764l1.5 3-1.5 3h-3.764l-1.5-3 1.5-3zm-8.5 7l1.5-3h3.764l1.5 3-1.5 3H6.618l-1.5-3zm12.264 7h-3.764l-1.5-3 1.5-3h3.764l1.5 3-1.5 3z",
    key: "k0"
  }));
});
Hive.displayName = 'Hive';
export var HiveDimensions = {
  height: 24,
  width: 24
};